import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import estimasiOkService from "../../../services/reports/estimasiOkService";
import Cookies from "js-cookie";

export const initialState = {
    loading_estimasi_ok: false,
    data_estimasi_ok: [],
    showMessage:false,
    message:'',
}


export const getDataEstimasiOk = createAsyncThunk('estimasi_ok/data',async (data, { rejectWithValue }) => {
    try {
        const response = await estimasiOkService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const estimasiOkSlice = createSlice({
    name: 'estimasi_ok',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_estimasi_ok = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataEstimasiOk.fulfilled, (state, action) => {
                state.loading_estimasi_ok = false
                state.data_estimasi_ok = action.payload??[]
            })
            .addCase(getDataEstimasiOk.pending, (state) => {
                state.loading_estimasi_ok = true
            })
            .addCase(getDataEstimasiOk.rejected, (state, action) => {
                state.loading_estimasi_ok = false
                state.data_estimasi_ok = action.payload
            })
    },
})

export const {
    showLoading,
} = estimasiOkSlice.actions

export default estimasiOkSlice.reducer
